export default __webpack_public_path__ + "static/media/original-profile-buyer.16503f5c.svg";